// Vendors
import { COBRANDED_LIGHT_REGULAR_BASE_STYLES } from '@openbank/ziniaweb-ui-components';
import { FoundationsCobrandedRegularTheme } from '@openbank/ziniaweb-ui-core-models';
import styled from 'styled-components';
// Utilities
import { convertPxsToRems } from '@openbank/cf-ui-framework';

const ContractComponentStyled = styled.section`
  display: flex;
  align-items: flex-start;
  gap: ${FoundationsCobrandedRegularTheme.spacing_300};
  align-self: stretch;

  ${COBRANDED_LIGHT_REGULAR_BASE_STYLES.MEDIA_QUERIES.mobileAndTablet} {
    flex-direction: column-reverse;
  }
`;
ContractComponentStyled.displayName = 'ContractComponentStyled';

const ContractPDFAndConsentsAreaStyled = styled.section`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: ${FoundationsCobrandedRegularTheme.spacing_250};
  max-width: min-content;
  border-radius: ${FoundationsCobrandedRegularTheme.radius_150};
  border: 1px solid ${FoundationsCobrandedRegularTheme.color_neutral_border_160};
  padding: ${FoundationsCobrandedRegularTheme.spacing_250};
  min-width: ${convertPxsToRems({ pixels: 685, base: 16 })};

  ${COBRANDED_LIGHT_REGULAR_BASE_STYLES.MEDIA_QUERIES.mobileAndTablet} {
    max-width: fit-content;
    min-width: 100%;
  }
`;

ContractPDFAndConsentsAreaStyled.displayName = 'ContractPDFAndConsentsAreaStyled';

const ContractPDFViewerComponentStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${convertPxsToRems({ pixels: 10, base: 16 })};
  align-self: stretch;
  position: relative;
  padding-top: calc(100% + 246rem);

  ${COBRANDED_LIGHT_REGULAR_BASE_STYLES.MEDIA_QUERIES.onlyTablet} {
    padding-top: calc(100% + 175rem);
  }

  ${COBRANDED_LIGHT_REGULAR_BASE_STYLES.MEDIA_QUERIES.onlyMobile} {
    padding-top: calc(100% + 100rem);
  }
`;
ContractPDFViewerComponentStyled.displayName = 'ContractPDFViewerComponentStyled';

const ContractPDFViewerAreaStyled = styled.div`
  justify-content: center;
  align-items: center;
  width: ${convertPxsToRems({ pixels: 685, base: 16 })};
  padding: ${({ theme }) => theme.spacing_250};
  border-radius: ${({ theme }) => theme.radius_150};
  background-color: ${({ theme }) => theme.color_neutral_screen_bg_450};

  ${COBRANDED_LIGHT_REGULAR_BASE_STYLES.MEDIA_QUERIES.mobileAndTablet} {
    width: 100%;
  }

  gap: ${FoundationsCobrandedRegularTheme.spacing_200};
`;
ContractPDFViewerAreaStyled.displayName = 'ContractPDFViewerAreaStyled';

const ContractPDFViewerDocumentAreaStyled = styled.div`
  overflow: auto;
  min-height: ${convertPxsToRems({ pixels: 480, base: 16 })};
  max-height: ${convertPxsToRems({ pixels: 480, base: 16 })};
`;
ContractPDFViewerDocumentAreaStyled.displayName = 'ContractPDFViewerDocumentAreaStyled';

const ConsentsTitleStyled = styled.div`
  font-weight: ${FoundationsCobrandedRegularTheme.font_weight_paragraph_medium_bold};
  font-size: ${FoundationsCobrandedRegularTheme.font_size_paragraph_medium};
`;
ConsentsTitleStyled.displayName = 'ConsentsTitleStyled';

const ConsentsContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${FoundationsCobrandedRegularTheme.spacing_250};
  align-self: stretch;
`;
ConsentsContainerStyled.displayName = 'ConsentsContainerStyled';

const SignatureDateStyled = styled.div`
  color: ${FoundationsCobrandedRegularTheme.color_neutral_font_100};
`;
SignatureDateStyled.displayName = 'SignatureDateStyled';

const SelectIbanContainerStyled = styled.section`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: ${FoundationsCobrandedRegularTheme.spacing_200};
  width: 100%;
`;
SelectIbanContainerStyled.displayName = 'SelectIbanContainerStyled';

const ContractSkeletonStyled = styled.div`
  position: relative;
  display: flex;
  padding: ${FoundationsCobrandedRegularTheme.spacing_250};
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: ${convertPxsToRems({ pixels: 685, base: 16 })};

  ${COBRANDED_LIGHT_REGULAR_BASE_STYLES.MEDIA_QUERIES.mobileAndTablet} {
    width: 100%;
  }
`;

ContractSkeletonStyled.displayName = 'ContractSkeletonStyled';

const ContractPDFViewerTitleAreaStyled = styled.h2`
  text-align: center;
`;
ContractPDFViewerTitleAreaStyled.displayName = 'ContractPDFViewerTitleAreaStyled';

export {
  ConsentsContainerStyled,
  ConsentsTitleStyled,
  ContractComponentStyled,
  ContractPDFAndConsentsAreaStyled,
  ContractPDFViewerAreaStyled,
  ContractPDFViewerComponentStyled,
  ContractPDFViewerDocumentAreaStyled,
  ContractPDFViewerTitleAreaStyled,
  ContractSkeletonStyled,
  SelectIbanContainerStyled,
  SignatureDateStyled,
};
